export type VenueSearchMode = "name" | "location";

const ADDRESS_KEYWORDS = [
  "street",
  "st",
  "avenue",
  "ave",
  "road",
  "rd",
  "boulevard",
  "blvd",
  "lane",
  "ln",
  "drive",
  "dr",
  "court",
  "ct",
  "highway",
  "hwy",
  "parkway",
  "pkwy",
  "place",
  "pl",
  "square",
  "sq",
  "trail",
  "trl",
  "way",
  "north",
  "south",
  "east",
  "west",
  "ne",
  "nw",
  "se",
  "sw",
  "zipcode",
  "suite",
  "unit",
];

const ZIP_CODE_REGEX = /^\d{5}(?:-\d{4})?$/;

const STATE_ABBREVIATIONS = [
  'al','ak','az','ar','ca','co','ct','de','fl','ga','hi','id','il','in','ia','ks','ky','la','me','md','ma','mi','mn','ms','mo','mt','ne','nv','nh','nj','nm','ny','nc','nd','oh','ok','or','pa','ri','sc','sd','tn','tx','ut','vt','va','wa','wv','wi','wy',
];

const STATE_NAMES = [
  'alabama','alaska','arizona','arkansas','california','colorado','connecticut','delaware','florida','georgia','hawaii','idaho','illinois','indiana','iowa','kansas','kentucky','louisiana','maine','maryland','massachusetts','michigan','minnesota','mississippi','missouri','montana','nebraska','nevada','new hampshire','new jersey','new mexico','new york','north carolina','north dakota','ohio','oklahoma','oregon','pennsylvania','rhode island','south carolina','south dakota','tennessee','texas','utah','vermont','virginia','washington','west virginia','wisconsin','wyoming',
  'district of columbia','washington dc','washington d.c.',
];

export function detectVenueSearchMode(query: string): VenueSearchMode {
  return isLikelyAddress(query) ? "location" : "name";
}

export function isLikelyAddress(query: string): boolean {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return false;

  if (ZIP_CODE_REGEX.test(normalized)) {
    return true;
  }

  if (/\d/.test(normalized)) {
    return true;
  }

  if (normalized.includes(",")) {
    return true;
  }

  if (ADDRESS_KEYWORDS.some((keyword) => normalized.includes(keyword))) {
    return true;
  }

  const tokens = normalized.split(/\s+/).filter(Boolean);
  if (tokens.length >= 2) {
    const last = tokens[tokens.length - 1];
    const secondLast = tokens.length > 1 ? tokens[tokens.length - 2] : '';

    if (STATE_ABBREVIATIONS.includes(last)) {
      return true;
    }

    if (STATE_ABBREVIATIONS.includes(secondLast) && last.length === 1) {
      return true;
    }

    if (STATE_NAMES.some((state) => normalized.includes(state))) {
      return true;
    }
  }

  return false;
}
